/**
 * محاسبه مبلغ خالص ردیف فاکتور/پیش‌فاکتور پس از تخفیف آیتم
 * @see ITEM_DISCOUNT_API_FRONTEND_GUIDE.md
 */

export const ITEM_DISCOUNT_TYPES = [
  { value: 'percent', label: 'درصدی' },
  { value: 'fixed', label: 'مبلغ ثابت' },
];

/**
 * @param {{ quantity?: number, cost_per_item?: number, discount?: number, discount_type?: string }} item
 * @returns {number}
 */
export function calculateItemAmount(item = {}) {
  const qty = Number(item.quantity) || 0;
  const price = Number(item.cost_per_item) || 0;
  const discount = Math.max(0, Number(item.discount) || 0);
  const gross = qty * price;
  const type = item.discount_type === 'fixed' ? 'fixed' : 'percent';

  if (type === 'percent') {
    const validPercent = Math.min(100, discount);
    const discountAmount = (gross * validPercent) / 100;
    return Math.max(0, Number((gross - discountAmount).toFixed(2)));
  }

  return Math.max(0, Number((gross - Math.min(gross, discount)).toFixed(2)));
}

/**
 * نرمال‌سازی فیلدهای تخفیف آیتم از پاسخ API
 */
export function mapItemDiscountFields(apiItem = {}) {
  const discount = Math.max(0, Number(apiItem.discount ?? 0));
  const discount_type = apiItem.discount_type === 'fixed' ? 'fixed' : 'percent';
  const cost_per_item = Number(apiItem.unit_price ?? apiItem.cost_per_item ?? 0);
  const quantity = Number(apiItem.quantity ?? 0);
  const amountFromApi = apiItem.amount != null ? Number(apiItem.amount) : null;
  const amount =
    amountFromApi != null && !Number.isNaN(amountFromApi)
      ? amountFromApi
      : calculateItemAmount({ quantity, cost_per_item, discount, discount_type });

  return { discount, discount_type, amount };
}

/**
 * نمایش خلاصه تخفیف آیتم برای جداول مشاهده
 */
export function formatItemDiscountLabel(item = {}, formatMoney) {
  const discount = Number(item.discount || 0);
  if (!discount) return '—';
  if (item.discount_type === 'fixed') {
    return typeof formatMoney === 'function' ? formatMoney(discount) : String(discount);
  }
  return `${discount}٪`;
}
